__turbopack_context__.v({
  "arrow": "_4Oz74W_arrow",
  "articleHost": "_4Oz74W_articleHost",
  "articleTitle": "_4Oz74W_articleTitle",
  "date": "_4Oz74W_date",
  "empty": "_4Oz74W_empty",
  "keywords": "_4Oz74W_keywords",
  "leadingSection": "_4Oz74W_leadingSection",
  "more": "_4Oz74W_more",
  "rank": "_4Oz74W_rank",
  "ranking": "_4Oz74W_ranking",
  "saved": "_4Oz74W_saved",
  "section": "_4Oz74W_section",
  "sectionHeading": "_4Oz74W_sectionHeading",
  "sidebar": "_4Oz74W_sidebar",
  "sourceCount": "_4Oz74W_sourceCount",
  "sourceName": "_4Oz74W_sourceName",
  "sources": "_4Oz74W_sources",
  "stickyGroup": "_4Oz74W_stickyGroup",
});
